import React, { Component } from "react";

class Navigation extends Component {
	render() {

		let links = [
			"Home",
			"Games",
			"About"
		];

		let content = links.map((x, i) => {
			return <a
				key={i}
				className="nav-item"
				href="/#"
			>{x}</a>
		});

		for (let i = content.length - 1; i > 0; i--)
			content.splice(i, 0, <div key={-i} className="nav-separator">::</div>);

		return (
			<div className="navigation" >
				{content}
			</div>
		);
	}
}

export default Navigation;